var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 73,
    height: 73,
    rx: 3.5,
    stroke: "#B6B6B6",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8337 37.8317H37.8337V42.8317H36.167V37.8317H31.167V36.165H36.167V31.165H37.8337V36.165H42.8337V37.8317Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.aa8573029a36defd0da059c7d9ac2b31.svg";
export { ForwardRef as ReactComponent };